<template>
  <div class="track_detail">
    <div class="no_detail" v-if="!logisticsTrackingSections.length">
      <span class="colorR">{{$t('page.not_find_tracking')}}</span>
    </div>
    <div class="track_detail_content" v-if="logisticsTrackingSections.length">
      <div v-for="(item, index) in logisticsTrackingSections" :key="index">
        <div class="track_detail_content_head flex" :class="{'marTop30': index > 0}">
          <div class="track_detail_content_country">
            <span v-show="langIsChinese">{{sectionTypeFilter(item.sectionType)}}-</span>
            <span v-show="item.country">{{item.country}}-</span>
            <a :href="filterWebsite(item.carrierCode)" target="_blank" class="color26">
              <span>（{{filterCarriers(item.carrierCode)}}）</span>
            </a>
          </div>
          <div class="detail_tag" :class="classObject(item.trackingStatus, item.searchStatus)">
            <i class="iconfont size16 IconB" :class="iconFilter(item.trackingStatus)"></i>
            <span>{{searchResultFilter(item.trackingStatus, item.searchStatus)}}</span>
          </div>
          <div v-if="item.searchStatus === 'Failure' && !item.trackingStatus" style="height:20px;line-height:20px;margin-top:10px;" class="colorR marRight30">{{$t('page.check_failure') + item.failureInfo.failureMessage}}</div>
          <div v-if="item.logisticsTracking" class="track_detail_content_time color66">{{$t('page.newest_data_tracked')}}：{{utils.timeFormat(item.lastSucceededSearchTime, 'yyyy-MM-dd hh:mm:ss')}}</div>
        </div>
        <div class="track_detail_content_line marTop15"></div>
        <div class="track_detail_content_box marTop20" v-if="item.logisticsTracking">
          <div class="track_detail_content_bar"></div>
          <div class="flex marBott10" v-for="(t, i) in reverce(item.logisticsTracking.items)" :key="i">
            <div class="track_detail_dot marRight30" :class="{'back26': i === 0}"></div>
            <div :class="{'color66': i !== 0}" style="width:150px" class="marRight30">{{t.trackingTime.dateTime ? utils.timeFormat(t.trackingTime.dateTime, 'yyyy-MM-dd hh:mm:ss') : ''}}</div>
            <div style="width: 80%">
              <div :class="{'color66': i !== 0}">{{t.description}}</div>
              <div :class="{'color66': i !== 0}" v-show="t.location.display" class="marTop5">
                <i class="iconfont icondingwei size14"></i>
                <span>{{t.location.display}}</span>
              </div>
            </div>

          </div>
        </div>
        <div class="track_detail_content_box marTop20" v-else>{{$t('page.not_found_temporaily')}}</div>
      </div>

    </div>
    <div class="track_detail_button flex" v-if="logisticsTrackingSections.length">
      <div class="flex">
        <a href="javascript:;"
          class="copy-text copy_button point color66 whiteSpace"
          @click="copyTip"
          ref="copyText"
          :data-to="filterTrack(logisticsTrackingSections)">{{$t('page.copy_tracking_content')}}</a>
        <!-- <a href="javascript:;"
          class="copy-link copy_button point color66"
          @click="copyTipLink"
          ref="copyLink"
          :data-link="linkDetail(logisticsTrackingSections)">{{$t('page.copy_tracking_url')}}</a> -->
      </div>
    </div>
    <div class="track_detail_button_s">
      <div class="copy_s">
        <span class="el-dropdown-link">操作<i class="el-icon-arrow-down el-icon--right"></i></span>
        <ul class="copy_list_s el-dropdown-menu">
          <li class="copy-text_s el-dropdown-menu__item" ref="copyText_s"  @click="copyTip" :data-to="filterTrack(logisticsTrackingSections)">{{$t('page.copy_tracking_content')}}</li>
          <li class="copy-link_s el-dropdown-menu__item" ref="copyLink_s" @click="copyTipLink" :data-link="linkDetail(logisticsTrackingSections)">{{$t('page.copy_tracking_url')}}</li>
          <li class="popper__arrow">
            <span class="top__arrow"></span>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
  import ClipboardJS from 'clipboard'
  import LocalStorage from '@/common/localStorage.js'

  export default {
  props: {
    detail: {
      type:Object,
      default: () =>{}
    },
    nums: {
      type:String,
      default: ''
    },
    index: ''
  },
  data () {
    return {
      lineText: [],
      trackingStatus: '',
      logisticsTrackingSections: [],
      langIsChinese: localStorage.getItem('lang') === 'zh-cn',
      lang:localStorage.getItem('lang')?localStorage.getItem('lang'):'zh-cn'
    }
  },
  created () {
    console.log('bb')
  },
  mounted () {
    let vm = this
    this.$nextTick(()=>{
      vm.copyFun()
    })

  },
  watch: {
    detail:{
      handler(n) {
          if (n.logisticsTrackingSections && n.logisticsTrackingSections.length) {
            this.logisticsTrackingSections = n.logisticsTrackingSections
          }
      },
      deep:true,
      immediate:true
    }
  },
  computed:{

  },
  methods: {
    filterWebsite(code){//链接到物流商官网
      let text = ''
      LocalStorage.get('carriers').map(function (item) {
        if (code === item.code) {
          text = item.officialWebsite
        }
      })
      return text
    },
    reverce(arr){
      let arr1 = JSON.parse(JSON.stringify(arr))
      return arr1.reverse()
    },
    filterCarriers (code) {
      let text = ''
      let vm = this
      LocalStorage.get('carriers').map(function (item) {
        if (code === item.code) {
          if (vm.$i18n.locale==='zh-cn'){
            text = item.zhName
          }
          if (vm.$i18n.locale==='en'){
            text = item.enName
          }
        }
      })
      return text
    },
    sectionTypeFilter (type) {
      switch (type) {
        case 'InternationalPostalOrigin':
          return '国际邮政-发件地'
          break
        case 'InternationalPostalDestination':
          return '国际邮政-目的地'
          break
        case 'InternationalPostal':
          return '国际邮政'
          break
        case 'InternationalExpress':
          return '国际快递'
          break
        case 'NormalExpress':
          return '普通快递'
          break
        case 'LogisticsAgent':
          return '物流货代'
      }
    },
    copyFun () {
      let c = new ClipboardJS('.copy-text', {
        text: function (trigger) {
          return trigger.getAttribute('data-to')
        }
      })
      let c_s = new ClipboardJS('.copy-text_s', {
        text: function (trigger) {
          return trigger.getAttribute('data-to')
        }
      })
      let l = new ClipboardJS('.copy-link', {
        text: function (trigger) {
          return trigger.getAttribute('data-link')
        }
      })
      let l_s = new ClipboardJS('.copy-link_s', {
        text: function (trigger) {
          return trigger.getAttribute('data-link')
        }
      })
      if (this.$refs.copyText) {
        this.$refs.copyText.addEventListener('click', function () {
          console.log(c.text)
        }, false)
      }
      if (this.$refs.copyText_s) {
        this.$refs.copyText_s.addEventListener('click', function () {
          console.log(c_s.text)
        }, false)
      }
      if (this.$refs.copyLink) {
        this.$refs.copyLink.addEventListener('click', function () {
          console.log(l.text)
        }, false)
      }
      if (this.$refs.copyLink_s) {
        this.$refs.copyLink_s.addEventListener('click', function () {
          console.log(l_s.text)
        }, false)
      }
    },
    beforeDestroy () {
      let a = new ClipboardJS('.copy-text', {
        text: function (trigger) {
          return trigger.getAttribute('data-to')
        }
      })
      let b = new ClipboardJS('.copy-text_s', {
        text: function (trigger) {
          return trigger.getAttribute('data-to')
        }
      })
      let c = new ClipboardJS('.copy-link_s', {
        text: function (trigger) {
          return trigger.getAttribute('data-link')
        }
      })
      a.destroy()
      b.destroy()
      c.destroy()
    },
    searchResultFilter (state, code) {
      if (state && state !== 'Pending') {
        switch (state) {
          case 'ArrivedDelivery':
            return this.$t('page.Pick_Up')
            break
          case 'Delivering':
            return this.$t('page.Delivering')
            break
          case 'Delivered':
            return this.$t('page.Delivered')
            break
          case 'DeliveryFailure':
            return this.$t('page.Undelivered')
            break
          case 'Return':
            return this.$t('page.Return')
            break
          case 'Exception':
            return this.$t('page.Exception')
            break
          case 'InTransit':
            return this.$t('page.In_Transit')
            break
          case 'NotFound':
            return this.$t('page.Not_Found')
            break
          case 'InfoReceived':
            return this.$t('page.Info_Received')
            break
        }
      } else {
        switch (code) {
          case 'Pending':
            return this.$t('page.in_query')
            break
          case 'Searching':
            return this.$t('page.in_query')
            break
          case 'Failure':
            return this.$t('page.query_failed')
            break
          case 'Success':
            return this.$t('page.query_successful')
            break
          case 'Suspend':
            return this.$t('page.in_query')
            break
          case 'UnsupportedSearch':
            return this.$t('page.not_supported_query')
            break
          case 'NotProvideTracking':
            return this.$t('page.not_provide_logistics')
            break
        }
      }

    },
    iconFilter (state) {
      switch (state) {
        case 'ArrivedDelivery':
          return 'icondaodakequ'
          break
        case 'Delivering':
          return 'iconpaisongtuzhong'
          break
        case 'Delivered':
          return 'iconchenggongpaisong'
          break
        case 'DeliveryFailure':
          return 'icontoudishibai'
          break
        case 'Return':
          return 'iconbaoguotuihui'
          break
        case 'Exception':
          return 'iconkenengyichang'
          break
        case 'InTransit':
          return 'iconyunshutuzhong'
          break
        case 'NotFound':
          return 'iconchaxunshibai'
          break
        case 'InfoReceived':
          return 'iconyubaofahuo'
          break
      }
    },
    classObject (state, code) {
      if (state && state !== 'Pending') {
        switch (state) {
          case 'ArrivedDelivery':
            return 'color0AB'
            break
          case 'Delivering':
            return 'colorF5C'
            break
          case 'Delivered':
            return 'color39D'
            break
          case 'DeliveryFailure':
            return 'colorF20'
            break
          case 'Return':
            return 'colorFF3'
            break
          case 'Exception':
            return 'colorFE6'
            break
          case 'InTransit':
            return 'colorF58'
            break
          case 'NotFound':
            return 'color289'
            break
          case 'InfoReceived':
            return 'color266'
            break
        }
      } else {
        switch (code) {
          case 'Pending':
            return 'color26'
            break
          case 'Searching':
            return 'color26'
            break
          case 'Failure':
            return 'colorF20'
            break
          case 'Success':
            return 'colorG2'
            break
          case 'Suspend':
            return 'color26'
            break
          case 'UnsupportedSearch':
            return 'colorF20'
            break
          case 'NotProvideTracking':
            return 'colorF20'
            break
        }
      }
    },
    linkDetail (detail) {
      const ml = process.env.NODE_ENV
      if (ml === 'development' || ml === 'test') {
         return `https://extcall.trackingyee.globalpcf.net/TYiframe/${this.lang}?nums=${this.nums}`
      } else if (ml === 'build') {
        return `https://extcall.trackingyee.com/TYiframe/${this.lang}?nums=${this.nums}`
      }
    },

    filterTrack (detail) {
      let vm = this
      console.log(detail)
      let text = ''
      let no = vm.trackingNo + '-' + '\n'
      detail.map(function (item) {
        text += vm.sectionTypeFilter(item.sectionType) + '-' + item.country + '-' + vm.filterCarriers(item.carrierCode) + '\n'
        if (item.logisticsTracking) {
          item.logisticsTracking.items.map(function (t) {
            text += vm.utils.timeFormat(t.trackingTime.dateTime, 'yyyy-MM-dd hh:mm:ss') + '-' + t.description + '\n'
          })
        } else {
          text += '暂无该段轨迹' + '\n'
        }
      })
      return text
    },
    copyTip () {
      this.$message({
        message: this.$t('page.success_copy_tracking_content'),
        type: 'success'
      })
    },
    copyTipLink () {
      this.$message({
        message: this.$t('page.success_copy_tracking_url'),
        type: 'success'
      })
    },
  }
}
</script>

<style scoped>
  .track_detail_button_s{
    display: none;
  }
.track_detail {
  padding: 15px 40px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
}
.no_detail {
  height: 32px;
  line-height: 32px;
}
.track_detail_content {
  width: 1200px;
}
.track_detail_content_head {
  height: 32px;
  line-height: 32px;
}
.track_detail_content_line {
  border-bottom: 1px solid #F5F5F5;
}
.track_detail_content_country {
  border-left: 2px solid #289efc;
  padding-left: 14px;
  width: 250px;
  margin-right: 50px;
  height: 16px;
  line-height: 16px;
  margin-top: 7px;
}
.track_detail_content_box {
  position: relative;
}
.track_detail_content_bar {
  position: absolute;
  border-left: 1px solid #D2D2D2;
  left: 3px;
  height: calc(100% - 20px);
  top: 10px;
}
.track_detail_dot {
  width: 7px;
  height: 7px;
  border-radius: 5px;
  background-color: #D2D2D2;
  margin-top: 4px;
}
.detail_tag {
  padding: 0 10px;
  height:16px;
  line-height: 16px;
  margin: 7px 0;
  border-radius:4px;
  text-align: center;
  margin-right: 30px;
}
.copy_button {
  padding: 0 10px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border: 1px solid #D2D2D2;
  border-radius: 5px;
  margin-right: 10px;
  box-sizing: border-box;
}
.copy_button:hover {
  background-color: #f5f5f5;
}
</style>
<style scoped>



  @media only screen and (min-width: 400px) and (max-width: 768px) {
    .logo_i2 img{
      width: 80%;
    }
    .track_detail_content {
      width: 100%;
    }
    .track_detail{
      padding:20px 0
    }
    .track_detail_content_head {
      flex-wrap: wrap;
      height: initial;
    }
    .track_detail_content_country{
      margin-right: 20px;
      width: initial;
    }
    .track_detail_button{
     display: none;
    }
    .track_detail_button_s{
      display: block;
      color: #289EFC;
      cursor: pointer;
      font-size: 12px;
      position: absolute;
      top: 20px;
      right: 20px;
    }
    .copy_s .copy_list_s{
      opacity: 0;
      transition: .3s;
    }
    .copy_s.el-icon-arrow-down{
      transition: .3s;
    }
    .copy_s:hover .el-icon-arrow-down{
      transform: rotate(180deg);
      transition: .3s;
    }
    .copy_s:hover .copy_list_s{
      opacity: 1;
      transition: .3s;
    }
    .copy_list_s{
      width: 70px;
      padding: 5px 0;
      position: absolute;
      right: 0;
      left: initial;
      top: 16px;
    }
    .copy_list_s >>>.el-dropdown-menu__item {
      padding: 0 10px;
      line-height: 26px;
      height: 26px;
    }
    .popper__arrow{
      position: absolute;
      left: 42px;
      top: -11px;
    }
    .top__arrow{
      display: inline-block;
      transform: rotate(90deg);
      position: relative;
    }
    .top__arrow::before {
      content: '';
      position: absolute;
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 8px solid #ebeef5;
    }

    .top__arrow::after {
      content: '';
      position: absolute;
      left: -8px;
      top: 50%;
      transform: translateY(-50%);
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 7px solid white;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 1366px) {
    .logo_i2 img{
      width: 80%;
    }
    .track_detail_content {
      width: 100%;
    }
    .track_detail{
      padding:20px 0
    }
    .track_detail_content_head {
      flex-wrap: wrap;
      height: initial;
    }
    .track_detail_content_country{
      margin-right: 20px;
      width: initial;
    }
    .track_detail_button{
      display: none;
    }
    .track_detail_button_s{
      display: block;
      color: #289EFC;
      cursor: pointer;
      font-size: 12px;
      position: absolute;
      top: 20px;
      right: 20px;
    }
    .copy_s .copy_list_s{
      opacity: 0;
      transition: .3s;
    }
    .copy_s:hover .el-icon-arrow-down{
      transform: rotate(180deg);
      transition: .3s;
    }
    .copy_s:hover .copy_list_s{
      opacity: 1;
      transition: .3s;
    }
    .copy_list_s{
      width: 70px;
      padding: 5px 0;
      position: absolute;
      right: 0;
      left: initial;
      top: 16px;
    }
    .copy_list_s >>>.el-dropdown-menu__item {
      padding: 0 10px;
      line-height: 26px;
      height: 26px;
    }
    .popper__arrow{
      position: absolute;
      left: 42px;
      top: -11px;
    }
    .top__arrow{
      display: inline-block;
      transform: rotate(90deg);
      position: relative;
    }
    .top__arrow::before {
      content: '';
      position: absolute;
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 8px solid #ebeef5;
    }

    .top__arrow::after {
      content: '';
      position: absolute;
      left: -8px;
      top: 50%;
      transform: translateY(-50%);
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 7px solid white;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/new/quickDetail.vue